/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import Swiper from 'swiper';
import 'swiper/css';
import './style.scss';
import { Thumbs }from 'swiper/modules';

console.log('postSliders');

document.addEventListener('DOMContentLoaded', () => {
    const postSliders = document.querySelectorAll('.post-slider');
    if(postSliders.length > 0){
        postSliders.forEach((slider)=>{
            const slides = slider.querySelector('.post-slider__slides.swiper');
            const filter = slider.querySelector('.post-slider__filter.swiper');
            var thumbsSlider = new Swiper(filter, {
                spaceBetween: 10,
                slidesPerView: 4,
                watchSlidesProgress: true,
              });
            new Swiper(slides, {
                spaceBetween: 10,
                modules: [Thumbs],
                thumbs: {
                  swiper: thumbsSlider,
                },
            });
            console.log("thumbs",thumbsSlider);
        });
    }
});
